import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filtroResultado'
})
export class FiltroStatusPipe implements PipeTransform {

  transform(arreglo: any[], texto: string): any[] {
    // console.log(texto);
    if(!texto){
      return arreglo;
    }

    if( arreglo.length === 0 ) {
      return arreglo;
    }
    texto = texto.toLocaleLowerCase();

    return arreglo.filter( item => {
     return item.estatus.toLowerCase().includes(texto);
    });
    // return arreglo;
  }

}